import { GetJobRatingStatusResponse } from '@taxfyle/api-internal/internal/job_rating_pb'
import Status = GetJobRatingStatusResponse.Status

export enum RatingStatus {
  Disabled = 'Disabled',
  Pending = 'Pending',
  Rated = 'Rated',
  NotReady = 'NotReady',
  NotApplicable = 'NotApplicable',
  Unknown = 'Unknown',
}

export interface JobRatingStatus {
  proRating: RatingStatus
  platformRating: RatingStatus
}

export const mapJobRatingStatus = (
  status: GetJobRatingStatusResponse.Status,
) => {
  switch (status) {
    case Status.PENDING:
      return RatingStatus.Pending
    case Status.NOT_READY:
      return RatingStatus.NotReady
    case Status.RATED:
      return RatingStatus.Rated
    case Status.DISABLED:
      return RatingStatus.Disabled
    case Status.NOT_APPLICABLE:
      return RatingStatus.NotApplicable
    default:
      return RatingStatus.Unknown
  }
}

export const mapToJobRatingStatus = (
  jobRatingStatusDto: GetJobRatingStatusResponse.AsObject,
): JobRatingStatus => ({
  proRating: mapJobRatingStatus(jobRatingStatusDto.proRating),
  platformRating: mapJobRatingStatus(jobRatingStatusDto.platformRating),
})
